/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_WochentagInputs */

const de__field_wochentag = /** @type {(inputs: _Field_WochentagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wochentag`)
};

/**

* @param {_Field_WochentagInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_wochentag = /** @type {((inputs?: _Field_WochentagInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_WochentagInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_wochentag(inputs)
});